import { Component } from "react";

export default class MathOperators extends Component {
  render() {

    const decimal_digits = Number(this.props.params.colDef?.decimal_digits) || null;
    const value = this.props.params.value;
    return (
      <div>
        {!isNaN(value)
          ? new Intl.NumberFormat("id-ID", {
            style: "decimal",
            minimumFractionDigits: decimal_digits,
          }).format(Number(value))
          : ""}
      </div>
    );
  }
}
